export default "__VITE_ASSET__DTH4qrNe__"